module.exports = __webpack_public_path__ + "img/university-bg.1798f810.jpg";